import { Radio } from "@mui/material";
import React from "react";
import { FlatList, TouchableOpacity, Text, View, StyleSheet } from "react-native";
import EmptyListCompnoent from "../../../../common/component/EmptyListComponent";
import { FONT_FAMILY, THEME_COLORS } from "../../../../common/themes";

interface CGTListingProps {
  data: any[];
  selected: { id: number };
  onSelect: (id: number | string) => void;
}

function CGTListing({ data, selected, onSelect }: CGTListingProps) {
  const renderItem = ({ item: cgtData }) => {
    return (
      <TouchableOpacity activeOpacity={0.8} style={styles.itemContainer} onPress={() => onSelect(cgtData)}>
        <View style={[styles.itemView, selected?.id === cgtData?.id ? styles.selected : styles.unselected]}>
          <Radio checked={selected?.id === cgtData?.id} color="primary" value={1} name="cgt" />
          <View style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
            <Text style={styles.text}>{cgtData?.fullName}</Text>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View style={{ maxHeight: "75%" }}>
      <View style={[styles.itemView, { paddingVertical: 0, paddingLeft: 58 }]}>
        <View style={{ flex: 1 }}>
          <Text style={[styles.header, { textAlign: "left" }]}>CGT NAME</Text>
        </View>
      </View>
      <FlatList
        data={data}
        scrollEnabled
        renderItem={renderItem}
        extraData={selected}
        keyExtractor={(item) => item.id.toString()}
        ListEmptyComponent={() => <EmptyListCompnoent emptyListText={"No CGT is available to assign"} />}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  itemContainer: {
    cursor: "pointer",
  },
  itemView: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 5,
  },
  selected: {
    backgroundColor: THEME_COLORS.sideMenuBg,
  },
  unselected: {
    border: `1px solid ${THEME_COLORS.sideMenuBg}`,
  },
  header: {
    fontFamily: FONT_FAMILY.semiBoldV3,
    fontSize: 15,
    textAlign: "center",
  },
  text: {
    fontSize: 15,
    fontFamily: FONT_FAMILY.primaryV3,
    textAlign: "center",
  },
  badgeText: {
    color: THEME_COLORS.white,
    textTransform: "uppercase",
  },
  suggestionBadge: { backgroundColor: THEME_COLORS.purple2, padding: 8, marginLeft: 6, height: 24, borderRadius: 12 },
});

export default React.memo(CGTListing);
